import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SignInRoutingModule } from './sign-in-routing.module';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ShowPasswordModule } from '../shared/directives/show-password/show-password.module';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfimationDialogModule } from '../shared/components/confimation-dialog/confimation-dialog.module';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};


@NgModule({
    declarations: [SignInComponent],
    imports: [
        CommonModule,
        SignInRoutingModule,
        FormsModule,
        FlexLayoutModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatInputModule,
        MatFormFieldModule,
        NgxMaskModule.forRoot(options),
        ShowPasswordModule,
        MatDialogModule,
        ConfimationDialogModule,
        MatSnackBarModule
    ]
})
export class SignInModule { }
